import { CDN_IMG_URL } from '~/shared/cdn/url';

const getProviderIcon = (handle = '') =>
  `${CDN_IMG_URL}/providers/new-icons/${handle}.svg`;

export default getProviderIcon;
